// extracted by mini-css-extract-plugin
export var container = "_2y-0";
export var icon = "_2y-1";